<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<template>
  <Transition name="slide-down">
    <div
      class="GlobalSearchDropdown"
      v-if="globalSearchStore.isDropdownSearchActive"
      @mouseleave="onClose"
      data-section-name="Main Page"
      data-section-number="20"
    >
      <div class="GlobalSearchDropdown__input-wrapper">
        <input
          ref="inputRef"
          class="GlobalSearchDropdown__input"
          type="text"
          :placeholder="'Type your search'"
          v-model="localSearchValue"
          @keyup.enter="onSearch"
          maxlength="50"
        />
        <!-- <i-local-close
          v-if="localSearchValue.length > 0"
          @click="onReset"
          class="GlobalSearchDropdown__ui-icon GlobalSearchDropdown__ui-icon--reset"
        /> -->
        <i-local-search @click="onSearch" class="GlobalSearchDropdown__ui-icon GlobalSearchDropdown__ui-icon--search" />
        <!-- <i-local-close @click="onClose" class="GlobalSearchDropdown__close" /> -->
      </div>
    </div>
  </Transition>
  <Transition name="fade" delay="0.3s">
    <div class="GlobalSearchDropdown-bg-blur" v-if="globalSearchStore.isDropdownSearchActive" @click="onClose"></div>
  </Transition>
</template>
<script setup lang="ts">
  import { useGAEventStore } from '@/store/GAEventTracking'
  import { useGlobalSearchStore } from '@/store/GlobalSearch'
  import { nextTick, ref, watch } from 'vue'

  const gaEvent = useGAEventStore()
  const globalSearchStore = useGlobalSearchStore()
  const inputRef = ref<HTMLInputElement | null>(null)
  const localSearchValue = ref('')
  const mouseOutCloseDelay = ref<ReturnType<typeof setTimeout> | null>(null)
  const passedMouseOutCloseDelay = ref(false) // prevent mouseout when opened dropdown in the begining.
  const OPEN_DELAY_MS = 100
  watch(
    () => globalSearchStore.isDropdownSearchActive,
    async (isDropdownSearchActive) => {
      if (isDropdownSearchActive) {
        await nextTick()
        localSearchValue.value = ''
        mouseOutCloseDelay.value = setTimeout(() => {
          passedMouseOutCloseDelay.value = true
        }, OPEN_DELAY_MS)
        inputRef.value?.focus()
        // gaEvent.pushActionEvent({
        //   sectionName: 'Main page',
        //   sectionNumber: `20`,
        //   interaction: ' section_view',
        // })
      }
    },
  )

  const onClose = () => {
    const isInputFocused = document.activeElement === inputRef.value
    if (passedMouseOutCloseDelay.value && !isInputFocused) {
      globalSearchStore.closeGlobalSearchDropDown()
      passedMouseOutCloseDelay.value = false
    }
  }
  const onSearch = () => {
    if (localSearchValue.value.trim() === globalSearchStore.searchedValue) {
      // Do fake load and close dropdown due to SameRoute Update not working.
      // If SearchValue is same and previous search.
      globalSearchStore.isLoadingSearchResult = true
      globalSearchStore.closeGlobalSearchDropDown()
      setTimeout(() => {
        globalSearchStore.isLoadingSearchResult = false
      }, 1000)
      return
    }
    globalSearchStore.goToGlobalSearchPage(localSearchValue.value)
    gaEvent.pushActionEvent({
      sectionName: 'Main Page',
      sectionNumber: 20,
      interaction: 'button_click',
      sectionContent: 'Search Icon',
    })
  }
</script>
<style lang="scss" scoped>
  .GlobalSearchDropdown {
    position: absolute;
    width: 100%;
    top: 80px;
    background: white;
    z-index: 0;
    background: #1e1f20;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 45px 0 90px; //for same color as nav. */
    padding: 70px 0 100px;
  }

  .GlobalSearchDropdown__close {
    position: absolute;
    right: -50px;
    top: -50px;
    cursor: pointer;
    color: white;
    transition: color 0.3s;
    &:hover {
      color: #242424 !important;
    }
  }

  .GlobalSearchDropdown__input-wrapper {
    position: relative;
  }

  .GlobalSearchDropdown__input {
    background: transparent;
    font-size: 24px;
    padding: 6px 58px 6px 2px;
    border-bottom: 1px solid #b5b5b5;
    transition: all 0.3s ease;
    outline: none;
    width: 650px;
    color: #b5b5b5;
    &:focus {
      .GlobalSearchDropdown__ui-icon--reset {
        display: block;
      }
    }
  }
  .GlobalSearchDropdown__ui-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-54%);
    cursor: pointer;
    color: #575757 !important;
    transition: color 0.3s;
    &:hover {
      color: var(--accent-color2) !important;
    }
  }
  .GlobalSearchDropdown__ui-icon--reset {
    width: 22px;
    height: 22px;
    right: 45px;
    /* display: none; */
  }
  .GlobalSearchDropdown__ui-icon--search {
    width: 31px;
    height: 31px;
    right: 3px;

    &:hover {
      color: var(--accent-color2) !important;
    }
  }
  .slide-down-enter-active {
    transition: all 0.3s ease-out;
  }
  .slide-down-leave-active {
    transition: all 0.2s ease-in;
  }
  .slide-down-enter-from {
    transform: translateY(-100%);
  }
  .slide-down-leave-to {
    transform: translateY(-100%);
  }

  .GlobalSearchDropdown-bg-blur {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.57);
    backdrop-filter: blur(11px);
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .fade-enter-active {
    transition: all 0.3s ease-out 0.2s;
  }
  .fade-leave-active {
    transition: all 0.2s ease-in;
  }
  .fade-enter-from {
    opacity: 0;
  }
  .fade-leave-to {
    opacity: 0;
  }

  @media #{$tablet} {
    .GlobalSearchDropdown__input {
      width: 500px;
    }
  }
</style>
